var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorldcupPanelArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 72030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00076 0C5.19 0.000151529 5.37171 0.070092 5.50554 0.19499L9.79077 4.19442C10.0697 4.45479 10.0697 4.87769 9.79077 5.13806C9.51181 5.39795 9.06006 5.39814 8.78122 5.13806L4.99924 1.60831L1.21878 5.13806C0.93988 5.39805 0.488127 5.39805 0.209231 5.13806C-0.0697435 4.87769 -0.0697435 4.45479 0.209231 4.19442L4.49446 0.19499C4.62843 0.069957 4.8113 0 5.00076 0Z",
    fill: "var(--fill-0, #3B5CD2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2863 9.33248V1.22118C4.2863 0.852963 4.60547 0.555081 5 0.555081C5.39453 0.555081 5.7137 0.852963 5.7137 1.22118V9.33248C5.7137 9.7007 5.39453 10 5 10C4.60547 10 4.2863 9.7007 4.2863 9.33248Z",
    fill: "var(--fill-0, #3B5CD2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldcupPanelArrow);
export default __webpack_public_path__ + "static/media/worldcup-panel-arrow.30bdfa5c6b1840dc04a388b6671af09b.svg";
export { ForwardRef as ReactComponent };